export class Flow {
  flows: string[];
}
